export default "__VITE_ASSET__604df2c6__"